import { render, staticRenderFns } from "./forex-detail.vue?vue&type=template&id=2f7207a8&scoped=true"
import script from "./forex-detail.vue?vue&type=script&lang=js"
export * from "./forex-detail.vue?vue&type=script&lang=js"
import style0 from "./forex-detail.vue?vue&type=style&index=0&id=2f7207a8&prod&lang=css"
import style1 from "./forex-detail.vue?vue&type=style&index=1&id=2f7207a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7207a8",
  null
  
)

export default component.exports